<template>
  <footer class="footer">
    <div class="footer__container">
      <div class="footer__top">
        <div class="footer__left">
          <FooterSubscriptionComponent />
        </div>
        <div class="footer__right">
          <FooterLinkComponent
            heading="About"
            :links="aboutLinks"
          />
          <FooterLinkComponent
            heading="Helpful Links"
            :links="helpfulLinks"
          />
          <FooterSocialLinkComponent
            heading="Social Media"
            :links="socialMediaLinks"
          />
        </div>
      </div>
      <hr>
      <div class="footer__bottom">
        <p class="footer__copyright">
          &copy; SiliconHIRE Pvt. Ltd. 2024 | 33 Radha Krishna Marga-2, Ghattekulo, Kathmandu 44600, Nepal
        </p>
      </div>
    </div>
  </footer>
</template>

  <script lang="ts">
  import {defineComponent, ref} from 'vue'
  import FooterLinkComponent from './FooterLinkComponent.vue'
  import FooterSocialLinkComponent from './FooterSocialLinkComponent.vue'
  import FooterSubscriptionComponent from './FooterSubscriptionComponent.vue'
  import FacebookIconPath from '@/images/icon-facebook.png'
  import InstagramIconPath from '@/images/icon-instagram.png'
  import TwitterIconPath from '@/images/icon-twitter.png'
  import LinkedinIconPath from '@/images/icon-linkedin.png'
  import YoutubeIconPath from '@/images/icon-youtube.png'

  interface Link{
    title: string
    url: string
  }

  interface SocialMediaLink {
    url: string
    imagePath: string
    imageAlt: string
  }

  export default defineComponent({
      components: {FooterLinkComponent, FooterSocialLinkComponent, FooterSubscriptionComponent},
      setup() {
          const aboutLinks = ref<Link[]>([
            {title: 'About MeroAdda', url: '/AboutUs'},
          ])
          const helpfulLinks = ref<Link[]>([
              {title: 'Frequently Asked Questions', url: '/Faq'},
              {title: 'Terms Of Service', url: '/Tos'},
              {title: 'Privacy Policy', url: '/PrivacyPolicy'},
              // TODO: Need to Uncomment this when design of this page is completed
              // {title: 'Help & Support', url: '/Help'},
              {title: 'Contact Us', url: '/ContactUs'},
          ])
          const socialMediaLinks = ref<SocialMediaLink[]>([
            {
              url: 'https://www.facebook.com/meroaddanp',
              imagePath: FacebookIconPath,
              imageAlt: 'Facebook',
            },
            {
              url: 'https://www.instagram.com/meroadda/?hl=en',
              imagePath: InstagramIconPath,
              imageAlt: 'Instagram',
            },
            {
              url: 'https://twitter.com/MeroAdda',
              imagePath: TwitterIconPath,
              imageAlt: 'Twitter',
            },
            {
              url: 'https://www.youtube.com/channel/UCfS-_BSaGYVy9a-1rDSF6IA',
              imagePath: YoutubeIconPath,
              imageAlt: 'Youtube',
            },
            {
              url: 'https://www.linkedin.com/company/meroadda/',
              imagePath: LinkedinIconPath,
              imageAlt: 'Linkedin',
            },
          ])
          return {
              helpfulLinks,
              socialMediaLinks,
              aboutLinks,
          }
      },
  })
  </script>

  <style lang="scss" scoped>
  @import '@/sass/module/components/footer-component';
  </style>
